import { AxiosClient } from "./AxiosClient";

export const sendCompanySearch = (company) => {
  try {
    return AxiosClient.post("cases/search", { company_name: company });
  } catch (e) {
    console.log(e);
  }
};

// Validate an Rx name before adding it. Returns
// { input_name, recommended_name, confidence }.
export const searchRx = (rx) => {
  return AxiosClient.post("cases/search", { rx });
};

export const sendCompanySearchBackUp = (company) => {
  try {
    return AxiosClient.post("cases/backup_search", { company_name: company });
  } catch (e) {
    console.log(e);
  }
};

export const validateURL = (url) => {
  try {
    return AxiosClient.post("cases/validateURL", { url: url });
  } catch (e) {
    console.log(e);
  }
};

export const searchCompanyForCorrectUrl = (company_name) => {
  try {
    return AxiosClient.post("cases/searchCompanyForCorrectUrl", {
      company_name,
    });
  } catch (e) {
    console.log(e);
  }
};

export const saveCase = (caseName, domain) => {
  try {
    return AxiosClient.post("cases/saveCase", { caseName, domain });
  } catch (e) {
    console.log(e);
  }
};

export const activateCase = (target, activate) => {
  try {
    return AxiosClient.post("cases/activateCase", { target, activate });
  } catch (e) {
    console.log(e);
  }
};

export const deleteCase = (target) => {
  try {
    return AxiosClient.post("cases/deleteCase", { target });
  } catch (e) {
    console.log(e);
  }
};

export const getCases = () => {
  try {
    return AxiosClient.get("cases/getCases");
  } catch (e) {
    console.log(e);
  }
};

export const getFeedAutocomplete = (q) => {
  return AxiosClient.get("feed/getAutocomplete", {
    params: { q },
  });
};
